<template>
	<div class="loginPage">
		<div class="c994dda2">

			<div class="_47c279e"></div>
			<div class="_99ad066">
				<div class="ds-theme"
					style="--ds-rgb-hover: 245 245 245; --ds-rgb-primary: 77 107 254; --ds-button-hover-color: #2563EB; --ds-bordered-secondary-button-color: var(--dsr-text-1); --ds-input-prefix-color: var(--dsr-text-1); font-size: var(--ds-font-size-m); line-height: var(--ds-line-height-m);">
					<div class="ds-auth-form-wrapper">
						<div class="ds-sign-up-form__icon">
							<img src="../../assets/pcLogo.png" style="height: 100px;">
						</div>
						<div class="ds-sign-up-form__main">
							<div class="ds-sign-up-form__main-hero">
								<div class="ds-sign-up-form__description">你所在地区仅支持手机号注册，只需一个 顶搜 账号，即可访问 顶搜
									的所有服务。</div>
								<div class="ds-form-item ds-form-item--none ds-form-item--label-m">
									<div class="ds-form-item__content">
										<div class="ds-input ds-input--none ds-input--bordered ds-input--l">
											<div class="ds-input__icon">
												<div class="ds-icon" style="font-size: 1em; width: 1em; height: 1em;">
												</div>
											</div>
											<div class="ds-input__prefix">+86</div><input type="tel"
												class="ds-input__input" placeholder="请输入手机号" size="1" value="">
										</div>
									</div>
									<div class="ds-form-item__feedback" data-transform-origin="top"></div>
								</div>
								<div class="ds-form-item ds-form-item--none ds-form-item--label-m">

									<div class="ds-input ds-input--none ds-input--bordered ds-input--l">
										<div class="ds-input__icon">
											<div class="ds-icon" style="font-size: 1em; width: 1em; height: 1em;"></div>
										</div><input type="password" class="ds-input__input" placeholder="请输入密码"
											size="1" value="">
										<div class="ds-input__password-toggle">
											<div class="ds-icon-button" tabindex="0"></div>
										</div>
									</div>
									<div class="ds-form-item__feedback" data-transform-origin="top"></div>
								</div>
								<div class="ds-form-item ds-form-item--none ds-form-item--label-m">
									<div class="ds-form-item__content">
										<div class="ds-input ds-input--none ds-input--bordered ds-input--l">
											<div class="ds-input__icon">
												<div class="ds-icon" style="font-size: 1em; width: 1em; height: 1em;">
												</div>
											</div><input type="password" class="ds-input__input" placeholder="请再次输入密码"
												size="1" value="">
											<div class="ds-input__password-toggle">
												<div class="ds-icon-button" tabindex="0"></div>
											</div>
										</div>
									</div>
									<div class="ds-form-item__feedback" data-transform-origin="top"></div>
								</div>
								<div class="ds-form-item ds-form-item--none ds-form-item--label-m">
									<div class="ds-form-item__content">
										<div class="ds-verify-code-form-item">
											<div
												class="ds-input ds-input--none ds-input--bordered ds-input--l ds-verify-code-form-item__verify-code-input">
												<div class="ds-input__icon">
													<div class="ds-icon"
														style="font-size: 1em; width: 1em; height: 1em;"></div>
												</div><input maxlength="6" type="tel" class="ds-input__input"
													placeholder="请输入验证码" size="1" value="">
											</div>
											<div role="button"
												class="ds-button ds-button--secondary ds-button--bordered ds-button--rect ds-button--l dsds-verify-code-form-item__verify-code-button"
												tabindex="0">发送验证码</div>
										</div>
									</div>
									<div class="ds-form-item__feedback" data-transform-origin="top"></div>
								</div>
								<div
									class="ds-form-item ds-form-item--none ds-form-item--label-m ds-sign-up-form__agreement-text">
									<div class="ds-form-item__content">注册即代表已阅读并同意我们的 <a
											href="https://view.officeapps.live.com/op/view.aspx?src=https://ai.iptzx.com/agreement.doc"
											target="_blank" rel="noopener noreferrer" class="ds-a ds-a--link"><span
												aria-hidden="true" tabindex="-1"
												style="position: fixed; user-select: none; opacity: 0; width: 0px; height: 0px; display: block;"></span>用户协议</a>
										与 <a href="https://view.officeapps.live.com/op/view.aspx?src=https://ai.iptzx.com/privacy.doc"
											target="_blank" rel="noopener noreferrer" class="ds-a ds-a--link"><span
												aria-hidden="true" tabindex="-1"
												style="position: fixed; user-select: none; opacity: 0; width: 0px; height: 0px; display: block;"></span>隐私政策</a>
									</div>
									<div class="ds-form-item__feedback" data-transform-origin="top"></div>
								</div>
								<div role="button"
									class="ds-button ds-button--primary ds-button--filled ds-button--rect ds-button--block ds-button--l ds-sign-up-form__register-button"
									tabindex="0">注册</div>
								<div class="ds-sign-up-form__form-footer">
									<div role="button"
										class="ds-button ds-button--primary ds-button--text ds-button--rect ds-button--s"
										tabindex="0">返回登录</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
			<div class="_5178cc4">
				<div class="ds-auth-footer">
					<a href="https://beian.miit.gov.cn" class="ds-a ds-a--link">
						<span aria-hidden="true" tabindex="-1"
							style="position: fixed; user-select: none; opacity: 0; width: 0px; height: 0px; display: block;"></span><span
							class="ds-text" style="color: var(--dsr-text-3, #D4D4D4);">渝ICP备19005330号</span></a><span
						class="ds-text" style="color: var(--dsr-text-3, #D4D4D4);">&nbsp;·&nbsp;</span><a
						href="mailto:service@deepseek.com" class="ds-a ds-a--link"><span aria-hidden="true"
							tabindex="-1"
							style="position: fixed; user-select: none; opacity: 0; width: 0px; height: 0px; display: block;"></span><span
							class="ds-text" style="color: var(--dsr-text-3, #D4D4D4);">联系我们</span></a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loginAct: '0',
				loginType: ['验证码登录', '密码登录']
			}
		},
		methods: {
			changeLogin(e) {
				this.loginAct = e
				console.log(e)
			}
		}
	}
</script>
<style>
	@import url('../../style/pub.css');
</style>